import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpFileUploadComponent from './adpFileUpload.component';

let adpFileUploadModule = angular.module('adpFileUpload', [
  uiRouter
])

.component('adpFileUpload', adpFileUploadComponent)

.name;

export default adpFileUploadModule;



// WEBPACK FOOTER //
// ./src/app/components/adpFileUpload/adpFileUpload.js